import { render, staticRenderFns } from "./individual-modal.vue?vue&type=template&id=4fdbebf2&"
import script from "./individual-modal.vue?vue&type=script&lang=js&"
export * from "./individual-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports